import { render, staticRenderFns } from "./group-strategy-tpl-use.vue?vue&type=template&id=1768c7b4&scoped=true&"
import script from "./group-strategy-tpl-use.vue?vue&type=script&lang=js&"
export * from "./group-strategy-tpl-use.vue?vue&type=script&lang=js&"
import style0 from "./group-strategy-tpl-use.vue?vue&type=style&index=0&id=1768c7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1768c7b4",
  null
  
)

export default component.exports